import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_toka from "../../assets/img/face_laszlo_toka.png";
import ShowMoreText from "react-show-more-text";
import proj_ai_driven_sports_anal from "../../assets/img/proj_ai_driven_sports_anal.png";

const Laszlo_Toka_AI_sport_analytics = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_ai_driven_sports_anal} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_toka}
              /* this will be the text on the banner */
              alt="AI-driven Sports Analytics: Predictive Modeling and Performance Optimization"
            />{" "}
            <p className="text7">László Toka</p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            <p className="text8">Department of Telecommunication and Artificial Intelligence, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In this project, the students will explore the intersection of sports analytics and 
            artificial intelligence, focusing on the development of predictive models to enhance 
            team strategies and individual performance. Students will apply mathematical techniques 
            such as statistical analysis, machine learning algorithms, and optimization to real-world 
            sports data, such as player statistics, game outcomes, and training metrics. By leveraging 
            AI, students will aim to predict future performance, identify key factors influencing 
            success, and optimize decision-making processes for coaches and athletes. This project 
            will not only deepen their understanding of applied mathematics in a sports context but 
            also equip them with practical skills in AI and data analytics, preparing them for careers 
            in the rapidly evolving field of sports technology.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Toka_AI_sport_analytics;